import { API_KEY } from "../utils/constants";
import authService from "./authService";

export async function fetchWithApiKey(url, options = {}) {
  // Obtener headers de autenticación del servicio
  const authHeaders = authService.getAuthHeaders();
  
  const headers = {
    ...authHeaders,
    ...options.headers,
    "X-API-Key": API_KEY, // Mantener la API key si es necesaria
  };

  const updatedOptions = {
    ...options,
    headers,
  };

  console.log('🔍 fetchWithApiKey - Realizando solicitud a:', url);
  console.log('📋 Headers enviados:', headers);
  console.log('⚙️ Opciones completas:', updatedOptions);

  try {
    const response = await fetch(url, updatedOptions);
    
    console.log('� Respuesta del servidor:', {
      status: response.status,
      statusText: response.statusText,
      ok: response.ok,
      url: response.url
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Error del servidor:', {
        status: response.status,
        statusText: response.statusText,
        body: errorText
      });
      
      // Si es error 401, el token ha expirado
      if (response.status === 401) {
        authService.removeToken();
        throw new Error('Token expirado. Por favor, inicia sesión nuevamente.');
      }
      
      throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    console.log('✅ Datos recibidos exitosamente:', data);
    return data;
    
  } catch (error) {
    console.error("❌ Error in fetchWithApiKey:", error);
    throw error;
  }
}